import React from 'react'
import { ShareWithoutVersion } from 'modules/versioning'
import InvitePeople, {
  ShareForInvite,
} from 'modules/shares/modals/ShareSettingsModal/InvitePeople'
import ShareMemberships, {
  ShareForMembershipList,
} from 'modules/shares/modals/ShareSettingsModal/ShareMemberships'

export const GuestsTitle = ({ guestsCount }: { guestsCount: number }) => (
  <>Guests {guestsCount > 0 && `(${guestsCount})`}</>
)

export const GuestsPanel = ({ share }: { share: ShareWithoutVersion }) => {
  return (
    <>
      <InvitePeople
        hideLabel
        data-testid="sharing-guests-invite"
        share={share as ShareForInvite['share']}
        filterMembers="Guests"
      />
      <ShareMemberships share={share as ShareForMembershipList} guestsOnly />
    </>
  )
}
